/**************
 Cart
 ***************/

window.hasViewedCart = sessionStorage.getItem('hasViewedCart') === 'true';

function markCartAsViewed() {
    window.hasViewedCart = true;
    sessionStorage.setItem('hasViewedCart', 'true');
    document.dispatchEvent(new CustomEvent('cartViewed'));
}

/**************
 UPSELL SWIPERS
 ***************/

// retrieve hidden upsell HTML
let upsellSlides = {};
document.querySelector('#hiddenUpsells').querySelectorAll('.miniCartUpsellsItem').forEach(item => {
    upsellSlides[item.dataset.sku] = item.outerHTML;
})

// delete the hidden upsells from the DOM
document.querySelector('#hiddenUpsells').remove();

// upsell swiper
let upsellSwiper = new Swiper(document.querySelector('#miniCartUpsellsSwiper'), {
    slidesPerView: 1,
    spaceBetween: 100,
    navigation: {
        nextEl: '.miniCartUpsellsSwiperNext',
        prevEl: '.miniCartUpsellsSwiperPrev',
    }
})


// inserts an upsell slide based on SKU
function insertUpsell(SKU) {
    if (!upsellSlides[SKU]) {
        console.log('SKU not found for upsell:', SKU);
        return;
    }
    upsellSwiper.appendSlide(upsellSlides[SKU])
    updateUpsells()
}

// since we're adding and removing slides, we need to re attach the event listeners
function updateUpsells() {

    // check if an upsell is an upgrade
    document.querySelectorAll(".miniCartUpsellsItem").forEach(function (element) {
        // get sku prefix (downcase) & pack size of cart item
        let prefix = element.dataset.sku.split('-')[0].toLowerCase();
        let packSize = parseInt(element.dataset.sku.split('-')[1][0]);
        let suffixLetter = element.dataset.sku.split('-')[1][1];
        // check if that product is already in the cart - the sku prefix will be the same and suffix is same letter but higher number
        let isProductInCart = cart.items.find(item => item.sku.split('-')[0].toLowerCase() === prefix && parseInt(item.sku.split('-')[1][0]) < packSize && item.sku.split('-')[1][1].toLowerCase() === suffixLetter);

        // if it is an upgrade - change text to upgrade
        if (isProductInCart) {
            element.querySelector('.miniCartUpsellsItemWrapATC').textContent = "Upgrade";
        } else {
            element.querySelector('.miniCartUpsellsItemWrapATC').textContent = "Add";
        }
    });


    // Add Upsell function
    document.querySelectorAll('.miniCartUpsellsItemWrapATC').forEach(function (element) {
        element.removeEventListener("click", addUpsellToCart); // remove previous listener
        element.addEventListener("click", addUpsellToCart);
    });


    // listen for upgrade button click
    document.querySelectorAll(".miniCartBodyItemUpgrade.active").forEach(function (element) {
        element.removeEventListener("click", upgradeItem); // remove previous listener
        element.addEventListener("click", upgradeItem);
    });
}


// add upsell to cart function
async function addUpsellToCart(event) {
    const element = event.currentTarget;

    // add loading animation
    this.classList.add("loading");

    // check if that product is already in the cart - the sku prefix will be the same and suffix is same letter but higher number
    // get sku prefix (downcase) & pack size of cart item
    let prefix = this.closest('.miniCartUpsellsItem').dataset.sku.split('-')[0].toLowerCase();
    let packSize = parseInt(this.closest('.miniCartUpsellsItem').dataset.sku.split('-')[1][0]);
    let suffixLetter = this.closest('.miniCartUpsellsItem').dataset.sku.split('-')[1][1];
    let isProductInCart = cart.items.find(item => item.sku.split('-')[0].toLowerCase() === prefix && parseInt(item.sku.split('-')[1][0]) < packSize && item.sku.split('-')[1][1].toLowerCase() === suffixLetter);

    // get variant ID from dropdown selector
    const variantID = this.closest('.miniCartUpsellsItem').dataset.variant;

    // create form data and add _upsell property for tracking
    let formData = {
        items: [{
            quantity: 1,
            id: variantID,
            properties: {
                _upsell: true
            },
        }]
    };

    // check for selling plan
    if (this.closest('.miniCartUpsellsItem').dataset.plan) {
        formData.items[0].selling_plan = this.closest('.miniCartUpsellsItem').dataset.plan
    }

    // add product upsell
    await addProduct(formData);


    // if product in cart  , remove it
    if (isProductInCart) {
        // remove old product
        await changeProduct({
            id: isProductInCart.key,
            quantity: 0,
        });
    }

    // remove loading animation
    this.classList.remove("loading");

    await openCart(false);
}

// upgrade item function
async function upgradeItem(event) {
    const element = event.currentTarget;
    // add loading animation
    this.classList.add("loading");

    // get key and sku
    let key = element.parentElement.getAttribute("key");
    let sku = cart.items.filter(item => item.key === key)[0].sku;
    let quantity = cart.items.filter(item => item.key === key)[0].quantity;

    // make the new sku - the sku will be the same but has a suffix has an S instead of an X
    // liv3365-1x -> liv3365-1s
    let newSku = sku.slice(0, -1).toLowerCase() + "s";

    // special case for quiz products
    if (sku.includes("QUIZ")) {
        newSku = sku.toLowerCase() // the quiz products have the same sku for subscription and one time
    }

    // remove this product from the cart first since the key can change when you start adding the cart
    await changeProduct({
        id: key,
        quantity: 0,
    });

    // find that product and add it to the cart
    // add _upsell property for tracking
    let upgrade = skuToProductData[newSku];
    await addProduct({
        items: [{
            quantity: quantity,
            id: upgrade.variantId,
            selling_plan: upgrade.sellingPlanId,
            properties: {
                _upsell: true
            }
        }]
    });

    // remove loading animation
    this.classList.remove("loading");

    await openCart(false);
}


/**************
 Fondue
 ***************/

const MAX_RETRIES = 10;
let retryCount = 0;

function checkFondueReady(delay) {
    if (retryCount >= MAX_RETRIES) return;
    if (window?.Fondue?.status === "ready") {
        window.Fondue.cart.getCartId = () => {
            window.Fondue.cart.registerCartId(cart.token);
        };
        return;
    }

    setTimeout(() => {
        checkFondueReady(delay * 2);
        retryCount++;
    }, delay);
}


// these SKUS don't get a free bag
let antiGiftSKUs = [];

let familyBundleSkus = [
    "LIV1153-24S", "LIV1153-24X", "LIV1153-12S", "LIV1153-12X",
    "LIV2254-24S", "LIV2254-24X", "LIV2254-12S", "LIV2254-12X",
    "LIV3365-24S", "LIV3365-24X", "LIV3365-12S", "LIV3365-12X"
]
const deluxeBundleSubSku = 'LIV6621-COM-1S'
const deluxeBundleOnceSku = 'LIV6621-COM-1X'


antiGiftSKUs.push(...familyBundleSkus)


let antiUpgradeSKUs = [
    "LIV5522-1X", "LIV5522-3X", "LIV5522-4X", "LIV5522-5X", "LIV4488-1X"
]

// these SKUS don't get header upsell/status bar
let antiHeaderSKUS = ["LIV5522-1X", "LIV5522-3X", "LIV5522-4X", "LIV5522-5X", "LIV5522-1S", "LIV5522-3S", "LIV5522-4S", "LIV5522-5S"]


// countdown timer
function startTimer() {
    timer = setInterval(() => {
        // convert string xx:xx time to MS
        let time = document.querySelector("#miniCartHeaderExpiresTime").innerHTML;
        let splitTime = time.split(':');
        let timeMs = (splitTime[0] * 60000) + (splitTime[1] * 1000);
        // increment time
        if (timeMs > 0) {
            timeMs -= 1000;
        } else {
            // remove timer, stop setInterval
            document.querySelector("#miniCartHeaderExpires").classList.add('active');

            stopTimer();
        }

        // convert MS to xx:xx format
        let minutes = Math.floor(timeMs / 60000);
        let seconds = ((timeMs % 60000) / 1000).toFixed(0);

        // fix time formatting
        if (seconds < 10) {
            seconds = "0" + seconds
        }
        newTime = minutes + ":" + seconds;
        document.querySelector("#miniCartHeaderExpiresTime").innerHTML = newTime;
    }, 1000);
}

// start timer
startTimer()

// stop timer
function stopTimer() {
    clearInterval(timer)
}

// Set a bundle progress item width
function setBundleFooterProgressWidth(element, width) {
    element.children[0].style = `width: ${width}`;
}

// re-entry lock so rapid quantity clicks don't fire overlapping syncs against the same cart
let syncingFreeGifts = false;

// sync free gifts: add/remove/adjust based on real cart total (excluding _free items)
async function syncFreeGifts() {
    // skip while another sync is in flight; the caller that finishes will leave the cart consistent
    if (syncingFreeGifts) return false;

    // skip if cart isn't loaded or is empty
    if (!cart || !cart.items || cart.item_count === 0) return false;

    // skip if liquid couldn't resolve the free product or free gift variants
    const freeProductVariantId = freeProduct?.variants?.[0]?.id;
    const freeGiftVariantId = freeGift?.variants?.[0]?.id;
    if (!freeProductVariantId || !freeGiftVariantId) return false;

    syncingFreeGifts = true;

    try {
        const realItems = cart.items.filter(item => !item.properties?._free);
        const realTotal = realItems.reduce((sum, item) => sum + item.final_line_price, 0);

        const familyBundleInCart = realItems.some(item => familyBundleSkus.includes(item.sku));
        const antiHeaderInCart = realItems.some(item => antiHeaderSKUS.includes(item.sku));
        const antiGiftInCart = realItems.some(item => antiGiftSKUs.includes(item.sku));

        // determine desired freeProduct quantity
        let desiredFreeProductQty = 0;
        if (realTotal >= freeProductThreshold && Shopify.country === "US" && !familyBundleInCart && !antiHeaderInCart) {
            desiredFreeProductQty = 1;
        }
        realItems.forEach(item => {
            if ((item.sku === deluxeBundleSubSku || item.sku === deluxeBundleOnceSku) && Shopify.country === "US") {
                desiredFreeProductQty += item.quantity;
            }
        });

        const shouldHaveFreeGift = freeGift.error !== 'json not allowed for this object' && !antiGiftInCart;

        // current gift state in cart
        const currentFreeProduct = cart.items.find(item => item.properties?._free && item.variant_id === freeProductVariantId);
        const currentFreeGift = cart.items.find(item => item.properties?._free && item.variant_id === freeGiftVariantId);

        const updates = {};
        const itemsToAdd = [];

        // sync freeProduct (whitening strips)
        if (desiredFreeProductQty > 0) {
            if (!currentFreeProduct) {
                itemsToAdd.push({id: freeProductVariantId, quantity: desiredFreeProductQty, properties: {_free: true}});
            } else if (currentFreeProduct.quantity !== desiredFreeProductQty) {
                updates[currentFreeProduct.key] = desiredFreeProductQty;
            }
        } else if (currentFreeProduct) {
            updates[currentFreeProduct.key] = 0;
        }

        // sync freeGift (velvet bag)
        if (shouldHaveFreeGift) {
            if (!currentFreeGift) {
                itemsToAdd.push({id: freeGiftVariantId, quantity: 1, properties: {_free: true}});
            } else if (currentFreeGift.quantity > 1) {
                updates[currentFreeGift.key] = 1;
            }
        } else if (currentFreeGift) {
            updates[currentFreeGift.key] = 0;
        }

        const hasChanges = Object.keys(updates).length > 0 || itemsToAdd.length > 0;
        if (!hasChanges) return false;

        // run updates first; bail if the response is an error so we don't overwrite cart with a status object
        if (Object.keys(updates).length > 0) {
            const response = await updateCart({updates});
            if (!response.items) return false;
            cart = response;
        }

        // add free items; on error, bail without re-fetching so we don't claim changes were made
        if (itemsToAdd.length > 0) {
            const response = await addProduct({items: itemsToAdd});
            if (response.status) return false;
            cart = await fetch("/cart.js").then(r => r.json());
        }

        return true;
    } finally {
        syncingFreeGifts = false;
    }
}

// open cart
async function openCart(skipFetch = false) {
    // fetch cart
        cart = await fetch("/cart.js")
            .then(response => response.json())

    if (!cart || !cart.items) return; // Prevent crashes if API fails or rate limits

    // remove shipping protection
    const protectionItems = cart.items.filter(item => item.handle === "shipping-protection-1");
    if (protectionItems.length > 0) {
        let updatePayload = {};
        protectionItems.forEach(item => {
            updatePayload[item.key] = 0;
        });
        let response = await updateCart({updates: updatePayload});
        if (response.items) cart = response;
        await openCart(true);
        return;
    }

    // sync free gifts in/out of cart based on real total (excluding _free items)
    const giftsChanged = await syncFreeGifts();
    if (giftsChanged) {
        await openCart(true);
        return;
    }

    // reset container
    document.querySelector("#miniCartBody").innerHTML = "";

    // reset state, everything is hidden and dynamic content is removed
    document.querySelector("#miniCartHeaderStatus")?.classList.remove("active");
    document.querySelector("#miniCartUpsellsFree")?.classList.remove("active");
    document.querySelector(".miniCartBodyItem.whitening")?.classList.remove("active");

    document.querySelector('#headerCart').setAttribute("data-count", cart.item_count);

    // update active body
    if (cart.item_count === 0) {
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartHeaderExpires").classList.add("active");
        document.querySelector("#miniCartFooter").classList.remove("active");


        if (!is_b2b) {
            document.querySelector("#miniCartUpsellsTitle").textContent = "Or get started here";
        }
        // open cart
        if (document.querySelector("#miniCart:not([open])")) {
            document.querySelector("#miniCart").showModal();
        }
        document.querySelector("body").classList.add("noScroll");
        markCartAsViewed();


        // show default upsells
        insertUpsell("liv7788-1x");


        return;
    }

    // if every remaining item is a free gift, clear the cart
    // occurs when the user removed the last paid item and only _free gifts remain
    if (cart.items.length > 0 && cart.items.every(item => item.properties?._free)) {
        await clearCart();
        await openCart();
        return;
    }

    // update state
    document.querySelector("#miniCartHeaderExpires").classList.remove("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartFooter").classList.add("active");
    document.querySelector("#miniCartHeaderGift").classList.remove("active");
    document.querySelector("#miniCartUpsellsFree")?.classList.add("active");


    // if cart doesn't contain an anti gift sku, show free gift message
    if (!cart.items.some(item => antiGiftSKUs.includes(item.sku))) {
        document.querySelector("#miniCartHeaderGift").classList.add("active");
    }

    // show free shipping bar if country is set to US and the element exists
    if (Shopify.country === "US" && document.querySelector("#miniCartHeaderStatus")) {
        // show status bar
        document.querySelector("#miniCartHeaderStatus")?.classList.add("active");

        // update title
        document.querySelector("#miniCartUpsellsTitle").textContent = "Want More? Here Are Some Best Sellers!";

        // update status message
        if (cart.total_price < freeShippingThreshold) {
            document.querySelector("#miniCartHeaderStatusTitle").innerHTML = `
            You are
            <b>${price(freeShippingThreshold - cart.total_price)}</b>
            away from
            <b>${document.querySelector("#miniCartHeaderStatusFreeShipping").getAttribute('label')}!</b>
        `;
        } else if (cart.total_price < freeProductThreshold) {
            document.querySelector("#miniCartHeaderStatusTitle").innerHTML = `
            You are
            <b>${price(freeProductThreshold - cart.total_price)}</b>
            away from
            <b>${document.querySelector("#miniCartHeaderStatusFreeProduct").getAttribute('label')}!</b>
        `;
        } else {
            // if cart contains an antiGiftSKU, don't show free gift text
            if (antiGiftSKUs.some(sku => cart.items.some(item => item.sku === sku))) {
                document.querySelector("#miniCartHeaderStatusTitle").innerHTML = `Enjoy free shipping!`;
            } else {
                document.querySelector("#miniCartHeaderStatusTitle").innerHTML = `Enjoy free shipping and your free gift!`;
            }
        }
        // update status bar
        if (cart.total_price < freeShippingThreshold) {
            setBundleFooterProgressWidth(document.querySelector("#miniCartHeaderStatusBarProgress1"), `${cart.total_price / freeShippingThreshold * 100}%`);
            setBundleFooterProgressWidth(document.querySelector("#miniCartHeaderStatusBarProgress2"), "0%");
            setBundleFooterProgressWidth(document.querySelector("#miniCartHeaderStatusBarProgress3"), "0%");
        } else if (cart.total_price === freeShippingThreshold) {
            setBundleFooterProgressWidth(document.querySelector("#miniCartHeaderStatusBarProgress1"), "100%");
            setBundleFooterProgressWidth(document.querySelector("#miniCartHeaderStatusBarProgress2"), "0%");
            setBundleFooterProgressWidth(document.querySelector("#miniCartHeaderStatusBarProgress3"), "0%");
        } else if (cart.total_price < freeProductThreshold) {
            setBundleFooterProgressWidth(document.querySelector("#miniCartHeaderStatusBarProgress1"), "100%");
            setBundleFooterProgressWidth(document.querySelector("#miniCartHeaderStatusBarProgress2"), "50%");
            setBundleFooterProgressWidth(document.querySelector("#miniCartHeaderStatusBarProgress3"), "0%");
        } else {
            setBundleFooterProgressWidth(document.querySelector("#miniCartHeaderStatusBarProgress1"), "100%");
            setBundleFooterProgressWidth(document.querySelector("#miniCartHeaderStatusBarProgress2"), "100%");
            setBundleFooterProgressWidth(document.querySelector("#miniCartHeaderStatusBarProgress3"), "100%");
        }

        // free shipping
        if (cart.total_price >= freeShippingThreshold) {
            document.querySelector("#miniCartHeaderStatusFreeShipping")?.classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderStatusFreeShipping")?.classList.remove("active");
        }

        // free product
        if (cart.total_price >= freeProductThreshold) {
            document.querySelector("#miniCartHeaderStatusFreeProduct")?.classList.add("active");

            // don't show for family bundle skus
            if (!familyBundleSkus.some(sku => cart.items.some(item => item.sku === sku))) {
                document.querySelector(".miniCartBodyItem.whitening")?.classList.add("active");
            }

            // don't show for antiHeaderSKUS
            if (antiHeaderSKUS.some(sku => cart.items.some(item => item.sku === sku))) {
                document.querySelector(".miniCartBodyItem.whitening")?.classList.remove("active");
            }


        } else {
            document.querySelector("#miniCartHeaderStatusFreeProduct")?.classList.remove("active");
        }
    } else {
        document.querySelector("#miniCartHeaderStatus")?.classList.remove("active");
    }

    // special case, if deluxe bundle is in cart, they get the gift (whitening strips)
    if (cart.items.some(item => item.sku === deluxeBundleSubSku || item.sku === deluxeBundleOnceSku) && Shopify.country === "US") {
        //
        let giftQuantity = 0;
        cart.items.forEach(function (item) {
            if (item.sku === deluxeBundleSubSku || item.sku === deluxeBundleOnceSku) {
                giftQuantity += item.quantity;
            }
        })
        if (cart.total_price >= freeProductThreshold) {
            giftQuantity++;
        }
        document.querySelector(".miniCartBodyItem.whitening")?.classList.add("active");
        document.querySelector(".miniCartBodyItem.whitening").querySelector('.miniCartBodyItemQty').textContent = `${giftQuantity}x`;

    }

    // if cart contains family bundle sku, hide gift bar
    if (familyBundleSkus.some(sku => cart.items.some(item => item.sku === sku))) {
        document.querySelector("#miniCartHeaderStatus")?.classList.remove("active");
    }

    // if cart contains an anti header sku, hide header
    if (antiHeaderSKUS.some(sku => cart.items.some(item => item.sku === sku))) {
        document.querySelector("#miniCartHeaderStatus")?.classList.remove("active");
    }

    // append cart
    cart.items.forEach(function (item) {
        // variant HTML
        function variantHTML() {
            if (item.variant_title) {
                return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
            }
            return "";
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // Quantity HTML
        function showQuantity() {
            if (item.properties?._free) {
                return "";
            } else if (freeProductIDs.includes(item.product_id) || item.sku === "LIV4488-1X") {
                return `<div class="miniCartBodyItemQuantity">
                        <button class="miniCartBodyItemQuantityMinus">-</button>
                        <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                        <button class="miniCartBodyItemQuantityPlus">+</button>
                    </div>`
            } else if (familyBundleSkus.includes(item.sku)) {
                return `<div class="miniCartBodyItemQuantity active" >
                        <button class="miniCartBodyItemQuantityMinus">-</button>
                        <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                        <button class="miniCartBodyItemQuantityPlus" disabled>+</button>
                    </div>`
            } else {
                return `<div class="miniCartBodyItemQuantity active">
                        <button class="miniCartBodyItemQuantityMinus">-</button>
                        <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                        <button class="miniCartBodyItemQuantityPlus">+</button>
                    </div>`
            }
        }

        let perMonthHTML = "";
        let variantIdToUse = item.variant_id || item.id;
        const divisor = perMonthMapping[`${item.product_id}_${variantIdToUse}`] || perMonthMapping[item.product_id] || perMonthMapping[item.product_id?.toString()] || perMonthMapping[variantIdToUse] || perMonthMapping[variantIdToUse?.toString()];
        if (divisor) {
            let pmValue = item.final_line_price / divisor;
            let pmString = price(pmValue);
            let pmText = (typeof perMonthTextFormat !== 'undefined' && perMonthTextFormat) ? perMonthTextFormat.replace('[value]', pmString) : pmString + " Per Month";
            perMonthHTML = `<div class="miniCartBodyItemPerMonth">${pmText}</div>`;
        }

        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200">
                <div>
                    <div class="miniCartBodyItemTitle">${item.product_title}</div>
                    ${variantHTML()}
                    ${subscriptionHTML()}

                    ${showQuantity()}

                </div>
                <div>
                    <button class="miniCartBodyItemRemove" ${item.properties?._free ? 'style="display:none"' : ''}>
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 375 516.7" style="enable-background:new 0 0 375 516.7;" xml:space="preserve"><style type="text/css">.st0{fill:#A7AAAC;}</style><path class="st0" d="M151.2,252c-9.6-9.9-25.5-10.1-35.4-0.4c-9.9,9.6-10.1,25.5-0.4,35.4L151.2,252zM169.6,342.5c9.6,9.9,25.5,10.1,35.4,0.4c9.9-9.6,10.1-25.5,0.4-35.4L169.6,342.5zM115.4,363.1c-9.6,9.9-9.4,25.7,0.4,35.4c9.9,9.6,25.7,9.4,35.4-0.4L115.4,363.1zM205.4,342.5c9.6-9.9,9.4-25.7-0.4-35.4c-9.9-9.6-25.7-9.4-35.4,0.4L205.4,342.5zM259.6,286.9c9.6-9.9,9.4-25.7-0.4-35.4c-9.9-9.6-25.7-9.4-35.4,0.4L259.6,286.9zM169.6,307.5c-9.6,9.9-9.4,25.7,0.4,35.4c9.9,9.6,25.7,9.4,35.4-0.4L169.6,307.5zM223.8,398c9.6,9.9,25.5,10.1,35.4,0.4c9.9-9.6,10.1-25.5,0.4-35.4L223.8,398zM205.4,307.5c-9.6-9.9-25.5-10.1-35.4-0.4c-9.9,9.6-10.1,25.5-0.4,35.4L205.4,307.5zM244.8,50c13.8,0,25-11.2,25-25s-11.2-25-25-25V50zM136.4,0c-13.8,0-25,11.2-25,25s11.2,25,25,25V0zM350,116.7c13.8,0,25-11.2,25-25s-11.2-25-25-25V116.7zM25,66.7c-13.8,0-25,11.2-25,25s11.2,25,25,25V66.7zM48.8,467.3l-17.9,17.5l0,0L48.8,467.3z M25,408.3h25H25zM115.4,286.9l54.2,55.6l35.8-34.9L151.2,252L115.4,286.9zM151.2,398l54.2-55.6l-35.8-34.9l-54.2,55.6L151.2,398zM223.8,252l-54.2,55.6l35.8,34.9l54.2-55.6L223.8,252zM259.6,363.1l-54.2-55.6l-35.8,34.9l54.2,55.6L259.6,363.1zM244.8,0H136.4v50h108.3V0zM350,66.7H25v50h325V66.7zM52.1,183.3h270.9v-50H52.1V183.3zM322.9,183.3c0.4,0,0.8,0.1,1.2,0.6c0.5,0.5,0.8,1.2,0.8,2.2h50c0-28.5-22.7-52.8-52.1-52.8V183.3zM325,186.1v222.2h50V186.1H325zM325,408.3c0,32.8-25.8,58.3-56.2,58.3v50c59.3,0,106.3-49.1,106.3-108.3H325zM268.7,466.7H106.3v50h162.5V466.7zM106.3,466.7c-14.7,0-29-6-39.6-16.9l-35.8,34.9c19.9,20.4,47,32,75.4,32V466.7zM66.7,449.8C56.1,438.9,50,424,50,408.3H0c0,28.5,11,56,30.9,76.4L66.7,449.8zM50,408.3V186.1H0v222.2H50zM50,186.1c0-1,0.4-1.7,0.8-2.2c0.5-0.5,0.9-0.6,1.2-0.6v-50C22.7,133.3,0,157.6,0,186.1H50z"/></svg>
                    </button>
                    <div class="miniCartBodyItemPrice">
                        ${perMonthHTML}
                        <div class="miniCartBodyItemPriceOriginal ${perMonthHTML ? 'has-per-month' : ''}">
                            <s>${item.original_line_price > item.final_line_price ? (price(item.original_line_price)) : ""}</s>
                            ${item.final_line_price === 0 ? "FREE" : price(item.final_line_price)} ${perMonthHTML ? 'due today' : ''}
                        </div>
                    </div>
                </div>
                <button class="miniCartBodyItemUpgrade button" ${item.properties?._free ? 'style="display:none"' : ''}> Subscribe Instead</button>
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount")?.textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus")?.addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus")?.addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove")?.addEventListener("click", function () {
            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // update cart in shopify
            cart = await changeProduct({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);
        }


    });

    // return early if customer is b2b
    if (is_b2b) {
        // show cart
        document.querySelector("#miniCart").showModal();
        document.querySelector("body").classList.add("noScroll");
        markCartAsViewed();

        if (window.Fondue.status === "ready") {
            // update Fondue
            await window.Fondue.cart.dispatchUpdatedCartEvent();
        }

        return;
    }

    // ----- Upgrade buttons/ Upsells -----

    // Reset upsells
    upsellSwiper.removeAllSlides();

    let mouthwashInCart = false;
    cart.items.forEach(function (item) {
        if (item.sku.split('-')[0].toLowerCase() === "liv7788") {
            mouthwashInCart = true;
        }
    })

    let mouthwash4PackInCart = false;
    cart.items.forEach(function (item) {
        if (item.product_id === 10140021883199 || item.product_id === 10140022047039) {
            mouthwash4PackInCart = true;
        }
    })

    let bundleInCart = false;
    cart.items.forEach(function (item) {
        if (item.sku.split('-')[0].toLowerCase() === "liv6621") {
            bundleInCart = true;
        }
    })

    // for each cart item
    cart.items.forEach(function (item) {
        // get sku prefix (downcase) & pack size of cart item

        // check if sku has a "-"
        if (!item.sku.includes("-")) {
            return;
        }

        // check if this is a free product
        if (freeProductIDs.includes(item.product_id)) {
            return;
        }

        if (cartUpgradeExcludedProductIds.includes(item.product_id)) {
            return;
        }

        let prefix = item.sku.split('-')[0].toLowerCase();
        let packSize = parseInt(item.sku.split('-')[1][0]);

        // if pack size is == 5, show 3 pack
        if (packSize === 5) {

            // if item is a one time product
            if (!item.selling_plan_allocation) {
                // find the item in the cart and add the upgrade button
                let element = document.querySelector(`.miniCartBodyItem[key="${item.key}"]`);

                // check for anti upgrade skus
                if (!antiUpgradeSKUs.includes(item.sku)) {
                    element?.querySelector(".miniCartBodyItemUpgrade").classList.add("active");
                }
            }

        } else {

            // if item is a one time product
            if (!item.selling_plan_allocation) {
                // find the item in the cart and add the upgrade button
                let element = document.querySelector(`.miniCartBodyItem[key="${item.key}"]`);

                // check for anti upgrade skus
                // or if it's mouthwash 15% off or bundle 20 off OR mouthwash sale don't show upgrade
                if (!antiUpgradeSKUs.includes(item.sku) && item.id !== 51562276520255 && item.id !== 51584200311103 && item.id !== 51585826259263) {
                    element?.querySelector(".miniCartBodyItemUpgrade").classList.add("active");
                }
            }
        }

    });

    // Upsells
    // if bundle in cart show 20% off bundle
    if (bundleInCart) {
        insertUpsell(`liv6621-com-1x`);
        insertUpsell(`liv7788-1x`);
        // mouthwash 4 pack
    } else if (mouthwash4PackInCart) {
        insertUpsell(`liv2298-3x`);
    } else {
        insertUpsell(`liv7788-1x`);
    }


    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellsItem")?.forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        }
    });

    // check if upsells empty
    if (upsellSwiper.slides.length === 0) {
        // show default upsells
        insertUpsell(`liv7788-1x`);
    }

    // add save amount to upgrade buttons
    // determined by the difference between the subscription and one time price
    document.querySelectorAll(".miniCartBodyItemUpgrade.active").forEach(function (element) {
        // get key and sku
        let key = element.parentElement.getAttribute("key");
        let sku = cart.items.filter(item => item.key === key)[0].sku;

        // find product
        let item = cart.items.filter(item => item.key === key)[0];

        // check if this is a free product
        if (freeProductIDs.includes(item.product_id)) {
            return;
        }

        // make the new sku - the sku will be the same but has a suffix has an S instead of an X
        // liv3365-1x -> liv3365-1s
        let newSku = sku.slice(0, -1).toLowerCase() + "s";


        // check if skuToProductData has the new sku
        if (!skuToProductData[newSku] || !skuToProductData[sku.toLowerCase()]) {
            return;
        }


        // get price difference from one time to subscription
        let priceSubscription = skuToProductData[newSku].price;
        let priceOneTime = skuToProductData[sku.toLowerCase()].price;
        let saveAmount = price(priceOneTime - priceSubscription);

        // add save amount to upgrade button
        element.textContent = `Click To Subscribe & Save ${saveAmount}`;

    });


    // show the shipping protection upsell if we're in the US

    if (Shopify.country === "US") {
        document.querySelector("#miniCartFooterGift").classList.add("active");
    } else {
        document.querySelector("#miniCartFooterGift").classList.remove("active");
    }

    document.querySelector("#miniCart").showModal();
    document.querySelector("body").classList.add("noScroll");
    markCartAsViewed();

    // update Fondue
    if (window.Fondue.status === "ready") {
        await window.Fondue.cart.dispatchUpdatedCartEvent();
    }

}

// close cart
function closeCart() {
    document.querySelector("#miniCart").close();
    document.querySelector("body").classList.remove("noScroll");
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click",
        function () {
            openCart();
        }
    );
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})


// checkout button
document.querySelector("#miniCartFooterTopCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // track jumble berry
    try {
        jumbleberry("track", "InitiateCheckout");
    } catch (e) {
    }

    // redirect to checkout — free gifts are already in the cart via syncFreeGifts()
    window.location.href = "/checkout";
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));

// open cart if referrer is cart
if (document.referrer === "https://getlivfresh.com/cart") {
    openCart();
}

async function log() {
    const cart = await fetch("/cart.js")
        .then(data => data.json())

    // console log every item in the cart by variant ID like Currently variant_1 varaint_2 are in the cart
    let variantIDs = cart.items.map(item => item.variant_id);
    console.log(`Currently ${variantIDs.map(id => `variant_${id}`).join(', ')} are in the cart`);

}

// SavedBy shipping protection checkbox
// When unchecked: fake button triggers sb__non-covered-link (SavedBy's own skip-protection flow).
// This avoids interception issues since SavedBy operates at the cart level, not just button clicks.
(function initSavedByProtectionToggle() {
    function findSkipLink(sbEl) {
        // try light DOM first, then shadow root if open
        return document.querySelector('a.sb__non-covered-link')
            || sbEl?.shadowRoot?.querySelector('a.sb__non-covered-link');
    }

    function injectControls() {
        const sbEl = document.querySelector('savedby-checkout-plus');
        if (!sbEl) return;

        const root = sbEl.shadowRoot || sbEl;

        const infoContainer = root.querySelector('.sb__info-container');
        if (!infoContainer) return;
        if (root.querySelector('#sb-protection-checkbox')) return;

        const checkoutContainer = root.querySelector('.sb__checkout-container');
        if (!checkoutContainer) return;

        const baseStyle = document.createElement('style');
        baseStyle.textContent = '.sb__non-covered-link { display: none !important; } .sb__checkout-container { gap: 0 !important; }';
        root.appendChild(baseStyle);

        infoContainer.insertAdjacentHTML('afterbegin', `
            <label id="sb-protection-checkbox-label" style="display:flex;align-items:center;gap:8px;cursor:pointer;">
                <input type="checkbox" id="sb-protection-checkbox" checked style="width:16px;height:16px;cursor:pointer;">
                <span style="display:none;">Add shipping protection</span>
            </label>
        `);

        checkoutContainer.insertAdjacentHTML('afterbegin', `
            <button id="sb-fake-checkout" style="display:none;max-width:none;width:100%;margin:0;border-radius:15px;text-transform:uppercase;padding:15px;background-color:var(--primary-blue);color:#fff;text-align:center;font-size:18px;font-weight:700;-webkit-appearance:none;appearance:none;cursor:pointer;">Checkout Now</button>
        `);

        const checkbox = infoContainer.querySelector('#sb-protection-checkbox');
        const fakeBtn = root.querySelector('#sb-fake-checkout');

        checkbox.addEventListener('change', function () {
            if (this.checked) {
                root.querySelector('#sb-hide-btn-style')?.remove();
                fakeBtn.style.display = 'none';
            } else {
                if (!root.querySelector('#sb-hide-btn-style')) {
                    const style = document.createElement('style');
                    style.id = 'sb-hide-btn-style';
                    style.textContent = '.sb__button-wrapper { display: none !important; }';
                    root.appendChild(style);
                }
                fakeBtn.style.display = '';
            }
        });

        fakeBtn.addEventListener('click', function () {
            const skipLink = findSkipLink(sbEl);
            if (skipLink) {
                skipLink.click();
            } else {
                window.location.href = '/checkout';
            }
        });
    }

    injectControls();

    const observer = new MutationObserver(injectControls);
    observer.observe(document.body, {childList: true, subtree: true});
})();
